import { marked } from 'marked';
import DOMPurify from 'dompurify';
import Cookies from 'js-cookie';

export default class Utils
{
	static toBR(str)
	{
		if (!str) return '';
		str = str.replace(/(\n)/g, '<br/>');
		str = str.replace(/(\[n1\])/g, '<br class="pc-only"/>');
		str = str.replace(/(\[n2\])/g, '<br class="sp-only"/>');
		return str;
	}

	static toBRP(str)
	{
		if (!str) return '';

		const reg1 = /(\n)/g;
		const reg2 = /(\[n1\])/g;
		const reg3 = /(\[n2\])/g;

		const classnames = [];

		if (str.match(reg1)) classnames.push('multi-line');
		str = str.replace(reg1, '<br/>');

		if (str.match(reg2)) classnames.push('multi-line-pc');
		str = str.replace(reg2, '<br class="pc-only"/>');

		if (str.match(reg3)) classnames.push('multi-line-sp');
		str = str.replace(reg3, '<br class="sp-only"/>');

		if (classnames.length == 0) classnames.push('single-line');

		return `<p class=${classnames.join(' ')}>${str}</p>`;
	}

	static markdownToHtml = (markdown) =>
	{
		if (!markdown) return '';

		// Escape tildes to prevent strikethrough parsing
		// Placeholder avoids underscores/asterisks which are markdown syntax
		const TILDE_PLACEHOLDER = 'ZWJTILDEZWJ';
		const escapedMarkdown = markdown.replace(/~/g, TILDE_PLACEHOLDER);

		marked.use({
			gfm: true,
			breaks: true,
		});

		const rawHtml = marked(escapedMarkdown);
		const sanitizedHtml = DOMPurify.sanitize(rawHtml);
		
		// Restore tildes after markdown processing
		const finalHtml = sanitizedHtml.replace(new RegExp(TILDE_PLACEHOLDER, 'g'), '~');
		
		return finalHtml;
	};

	static calculateDistance(lat1, lon1, lat2, lon2)
	{
		const R = 6371; // Earth's radius in km
		const dLat = (lat2 - lat1) * Math.PI / 180;
		const dLon = (lon2 - lon1) * Math.PI / 180;
		const a = 
			Math.sin(dLat/2) * Math.sin(dLat/2) +
			Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
			Math.sin(dLon/2) * Math.sin(dLon/2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
		return R * c; // Distance in km
	}
	
	static setCookie(name, value, days = 365)
	{
		Cookies.set(name, value, { 
			expires: days,
			sameSite: 'strict'
		});
	}
	
	static getCookie(name, defaultValue = null)
	{
		const value = Cookies.get(name);
		return value !== undefined ? value : defaultValue;
	}

	static styleChars(html, lang)
	{
		if (!html) return html;

		const STYLE_RULES =
		[
			{
				pattern: /[āĀēĒīĪōŌūŪ]/g,
				className: 'macron'
			}
		];

		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;

		function processNode(node)
		{
			if (node.nodeType === 3)
			{
				let newText = node.textContent;
				STYLE_RULES.forEach(rule => {
					newText = newText.replace(rule.pattern, match => 
						`<span class="${rule.className}">${match}</span>`
					);
				});
				
				if (newText !== node.textContent)
				{
					const span = document.createElement('span');
					span.innerHTML = newText;
					node.parentNode.replaceChild(span, node);
				}
			}
			else 
			{
				node.childNodes.forEach(processNode);
			}
		}

		processNode(tempDiv);

		return tempDiv.innerHTML;
	}
}
